import styled, { css } from 'styled-components';

const shouldForwardProp = prop => !['isChecked'].includes(prop);

export const TermsStyled = styled.div.withConfig({ shouldForwardProp })`
  padding: 30px 16px;

  .terms_container {
    display: flex;
    flex-direction: column;
    gap: 30px;
    padding-bottom: 70px;
  }

  .terms_title {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .terms_checkbox {
    margin-top: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px;
    border-radius: 8px;
    background: var(--GrayScale-100);
    div {
      color: var(--GrayScale-700);
    }
    ${props => {
      if (props.isChecked) {
        return css`
          background: var(--Primary-50);
          div {
            color: var(--Primary-500);
          }
        `;
      }
    }}
  }

  .button_container {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    padding: 10px 16px 30px 16px;
    background: var(--GrayScale-0);
  }
`;
